import { api } from '@/global/api'
import {
  ContractOrigin,
  Phone
} from '@/modules/accredited-establishments/api/types'

export interface GetProviderDetailResponse {
  title: string
  thumbnail?: string
  category?: string
  icon?: string
  cnpj?: string
  contractOrigin: ContractOrigin
  subCategories?: string
  includedPlans?: string[]
  phones?: Phone[]
  address?: string
  /* Opcionais ate alice-health/mono#46744 e #46746 entrarem em producao. */
  lat?: string
  lon?: string
}

export const getProviderDetails = async (
  referenced_id: string
): Promise<GetProviderDetailResponse> => {
  const { data } = await api.get<GetProviderDetailResponse>(
    `/site_accredited_network/accredited_provider/${referenced_id}`
  )
  return data
}
